/** Strip storage prefixes: ``v{n}_{ts}_`` (nested), then bare promote-style ``v{n}_``. */
export function stripStorageVersionPrefixesFromBasename(name: string): string {
  let base = name.trim();
  if (!base) {
    return name;
  }
  for (;;) {
    const m = /^v\d+_\d+_(.+)$/i.exec(base);
    if (!m) {
      break;
    }
    base = m[1];
  }
  const bareMajor = /^v\d+_(.+)$/i.exec(base);
  if (bareMajor) {
    base = bareMajor[1];
  }
  return base || name;
}

export function sanitizeAttachmentBasename(name: string): string {
  const leaf = stripStorageVersionPrefixesFromBasename(name || "document.docx");
  return leaf.replace(/[^\w\-_.]/g, "_") || "document.docx";
}

export function sanitizeUploadFilename(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) {
    return "document.docx";
  }
  const safe = trimmed.replace(/[/\\?%*:|"<>]/g, "-").trim();
  if (!safe) {
    return "document.docx";
  }
  return /\.(docx?|doc)$/i.test(safe) ? safe : `${safe}.docx`;
}

export function storageBasenameFromUserInput(rawBasename: string): string {
  return sanitizeAttachmentBasename(sanitizeUploadFilename(rawBasename));
}

export function formatPromoteUploadFilenamePattern(
  majorVersion: number,
  rawBasename: string,
): string {
  const safe = storageBasenameFromUserInput(rawBasename);
  const major = Number.isFinite(majorVersion) ? majorVersion : 0;
  return `v${major}_${safe}`;
}

export function prepareUploadFilename(pattern: string): string {
  return sanitizeUploadFilename(pattern);
}

export function suggestBasenameFromRawFilename(raw: string): string {
  const stripped = stripStorageVersionPrefixesFromBasename(raw.trim());
  if (!stripped) {
    return "document";
  }
  const safe = sanitizeAttachmentBasename(stripped);
  return safe.replace(/\.(docx?|doc)$/i, "") || "document";
}

export function suggestBasenameForPromote(sourceDocFilename?: string | null): string {
  const raw = (sourceDocFilename ?? "").trim();
  if (!raw) {
    return "document";
  }
  return suggestBasenameFromRawFilename(raw);
}

export function suggestPromoteUploadFilenamePattern(
  nextMajorVersion: number,
  sourceDocFilename?: string | null,
): string {
  return formatPromoteUploadFilenamePattern(
    nextMajorVersion,
    suggestBasenameForPromote(sourceDocFilename),
  );
}
